import { render, staticRenderFns } from "./TradingList.vue?vue&type=template&id=34359498&scoped=true"
import script from "./TradingList.vue?vue&type=script&lang=js"
export * from "./TradingList.vue?vue&type=script&lang=js"
import style0 from "./TradingList.vue?vue&type=style&index=0&id=34359498&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34359498",
  null
  
)

export default component.exports